import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
export const CurrencyPicker = ({
  availableCurrencies,
  selectedCurrency,
  onChange
}) => {
  const currencyOptions = availableCurrencies.map(availableCurrency => ({
    text: `${availableCurrency} (${I18n.currencySymbols[availableCurrency].symbol})`,
    value: availableCurrency
  }));
  return /*#__PURE__*/_jsx(Select, {
    buttonUse: "transparent",
    menuWidth: 200,
    menuHeight: 320,
    options: currencyOptions,
    onChange: onChange,
    defaultValue: selectedCurrency,
    value: selectedCurrency,
    "data-selenium-id": "currency-picker"
  });
};